// First child inside the '/*' ProtectedRoute (architecture sprint-05 §6.6). After sign-in the SDK lands
// on '/', password or SSO alike (A-10: jig-auth-sdk 1.10.2 sso-callback redirects to '/'); this sends
// the user on to a pending shared link. take() removes it, so a StrictMode double effect navigates once.
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { takeReturnTo } from '@/lib/return-to';

export function ReturnToRedirect(): null {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  useEffect(() => {
    const target = takeReturnTo();
    if (target && target !== pathname) navigate(target, { replace: true });
    // Only on mount: a later pathname change is the user navigating, not a sign-in landing.
  }, []);

  return null;
}
